// COMPONENTS
import { StyledLoginCTA } from "./styled";
import { StyledFormBG } from "../../styles/FormBG";
import LoginHeader from "../../components/LoginHeader";
import FormDefault from "../../components/Form";
import InputBox from "../../components/InputBox";
import { StyledBtn, StyledLink } from "../../styles/Buttons";

import { loginSchema } from "../../schemas/schemas";

//CONTEXT
import { useContext } from "react";
import { UserContext } from "../../context/userContext";

//LIBS
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";

const LoginPage = ()=>{
    
    const { submitLogin } = useContext(UserContext);

    const { register, handleSubmit, formState:{errors}, reset } = useForm({ 
        mode: "onBlur",
        resolver: yupResolver(loginSchema)
    });

    return(
        <StyledFormBG>
            <LoginHeader/>
            <FormDefault title="Login" callback={handleSubmit(submitLogin)}>
                
                <InputBox
                    label="Email" placeholder="Digite aqui seu email"
                    type="text" register={register("email")}
                    name="email" errors={errors.email}/>

                <InputBox
                    label="Senha" placeholder="Digite aqui sua senha"
                    type="password" register={register("password")}
                    name="senha" errors={errors.password}/>

                <StyledBtn BGcolor="var(--color-primary)" size={"100%"}>Entrar</StyledBtn>
                <StyledLoginCTA>Ainda não tem uma conta?</StyledLoginCTA>
                <StyledLink to="/register" size={"100%"}>Registrar</StyledLink>

            </FormDefault>

        </StyledFormBG>
        
    )

}

export default LoginPage